"use client";

import { useEffect, useMemo } from "react";
import { resolveBool, resolvePath } from "./binding";
import type { MacaronRenderContext, RecordAny } from "./types";

export function MacaronBooleanAllOf({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const outputPath = resolvePath(config.output);
  const updateData = ctx.updateData;
  const inputs = useMemo(
    () =>
      (Array.isArray(config.inputs) ? config.inputs : []).filter(
        (input): input is RecordAny => Boolean(input && typeof input === "object" && (typeof input.path !== "string" || input.path !== outputPath)),
      ),
    [config.inputs, outputPath],
  );
  const nextValue = useMemo(() => inputs.length > 0 && inputs.every((input) => resolveBool(input, ctx.data)), [ctx.data, inputs]);

  useEffect(() => {
    if (!outputPath) return;
    updateData?.(outputPath, nextValue);
  }, [nextValue, outputPath, updateData]);

  return null;
}
